"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentSettingsDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../base-utils/map-creator");
var destination_1 = require("../destination");
var compat_settings_destination_1 = require("./compat-settings-destination");
var default_tab_stop_destination_1 = require("./default-tab-stop-destination");
var different_odd_and_even_pages_destination_1 = require("./different-odd-and-even-pages-destination");
var document_protection_1 = require("./document-protection");
var document_variables_destination_1 = require("./document-variables-destination");
var mirror_margins_destination_1 = require("./mirror-margins-destination");
var DocumentSettingsDestination = (function (_super) {
    tslib_1.__extends(DocumentSettingsDestination, _super);
    function DocumentSettingsDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DocumentSettingsDestination.prototype, "elementHandlerTable", {
        get: function () {
            return DocumentSettingsDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    DocumentSettingsDestination.handlerTable = new map_creator_1.MapCreator()
        .add('defaultTabStop', function (data) { return new default_tab_stop_destination_1.DocumentSettingsDefaultTabStopDestination(data); })
        .add('evenAndOddHeaders', function (data) { return new different_odd_and_even_pages_destination_1.DocumentSettingsDifferentOddAndEvenPagesDestination(data); })
        .add('documentProtection', function (data) { return new document_protection_1.DocumentProtectionDestination(data); })
        .add('compat', function (data) { return new compat_settings_destination_1.DocumentSettingsCompatDestination(data); })
        .add('docVars', function (data) { return new document_variables_destination_1.DocumentSettingsDocVarsDestination(data); })
        .add('mirrorMargins', function (data) { return new mirror_margins_destination_1.DocumentSettingsMirrorMarginsDestination(data); })
        .get();
    return DocumentSettingsDestination;
}(destination_1.ElementDestination));
exports.DocumentSettingsDestination = DocumentSettingsDestination;
